import { ProtectedResourceScopes } from '@azure/msal-angular';
import { BrowserCacheLocation, InteractionType, LogLevel } from '@azure/msal-browser';
import { Settings } from '../app/app.settings';
import { loggerCallback } from './common';

export const prodSettings: Settings = {
  baseUrl: 'https://seed-insecta-api.se.research.vylor.com',
  environment: 'prod',
  isProd: true,
  appInsightsConnectionString:
    'InstrumentationKey=46dec030-9c81-4fd8-b7bd-79cafbcec468;IngestionEndpoint=https://centralus-2.in.applicationinsights.azure.com/;LiveEndpoint=https://centralus.livediagnostics.monitor.azure.com/;ApplicationId=2ab26736-f98f-4f7b-8884-3156d6565dc9',
  msal: {
    config: {
      auth: {
        clientId: '1753c17c-1c8b-40d3-ab67-d6f0509bd623',
        authority: 'https://login.microsoftonline.com/db505480-8ec6-495c-b579-32c58ed84a01/',
        redirectUri: 'https://seed-insecta.se.research.vylor.com/after-login',
        postLogoutRedirectUri: 'https://seed-insecta.se.research.vylor.com/after-logout',
        navigateToLoginRequestUrl: true
      },
      cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage
      },
      system: {
        loggerOptions: {
          loggerCallback,
          logLevel: LogLevel.Warning,
          piiLoggingEnabled: false
        }
      }
    },
    guard: {
      interactionType: InteractionType.Redirect
    },
    interceptor: {
      interactionType: InteractionType.Redirect,
      protectedResourceMap: new Map<string, Array<string | ProtectedResourceScopes> | null>([
        ['https://seed-insecta-api.se.research.vylor.com', ['api://1753c17c-1c8b-40d3-ab67-d6f0509bd623/API.Call']]
      ])
    }
  }
};
